import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_UPGRADE, SNACKBAR_ID_UPGRADE } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SNACKBAR_UPGRADE_TEXT } from './constants';
import { onUpgradeApply } from './onUpgradeApply';
import { SnackbarVariant } from '../../store/types';

export const snackbarUpgradeDefault = (
) => {
    return (dispatch: Dispatch) => {
        const id = SNACKBAR_ID_UPGRADE;
        const buttons = [{
            onClick: () => dispatch(getDefaultActionEvent(id, onUpgradeApply)),
            text: SNACKBAR_BUTTON_UPGRADE
        }];
        dispatch(addUpdateSnackbarWithBubble({
            id,
            buttons,
            text: SNACKBAR_UPGRADE_TEXT,
            icon: 'info',
            title: null,
            variant: SnackbarVariant.UPGRADE,
        }));
    }
};
